import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const CONSENT_KEY = "cookie_consent";
const usePageTracking = () => {
    const location = useLocation();
    useEffect(() => {
        const consent = localStorage.getItem(CONSENT_KEY);
        if (window.gtag &&
            consent === "granted" &&
            window.location.hostname === "log.soccer") {
            window.gtag("event", "page_view", {
                page_path: location.pathname,
            });
        }
    }, [location.pathname]);
};
export default usePageTracking;
